const Popover = ($ => {
	const Default = {
		delay: { show: 300, hide: 600 },
		trigger: 'focus',
		template: '<div class="popover" role="tooltip">' +
		'<svg class="popover-close icon-svg" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>' +
		'<div class="arrow"></div>' +
		'<h3 class="popover-header"></h3>' +
		'<div class="popover-body"></div></div>',
		sanitize: false, // svg close icon
	};

	class Popover {
		constructor(element, name, config) {
			this.element = element;
			this.name = name;
			this.$element = $(this.element);
			this.config = Object.assign({}, Default, config);
			this.instance = undefined;

			this.prepare();

			this.initPopover();
		}

		prepare() {
		}

		initPopover() {
			this.instance = this.$element.popover(this.config);

			this.$element.on('click', function(e){
				e.stopPropagation();
				return false;
			});

			this.$element.on('shown.bs.popover', function (e) {
				$(this).addClass('active');
			});

			this.$element.on('inserted.bs.popover', function (e) {

				let id = e.target.getAttribute('aria-describedby');

				$('#'+id).find('.popover-close').on('click', function(){
					this.$element.popover('hide');
				}.bind(this));

			}.bind(this));

			if (
				this.config.trigger == 'focus' ||
				this.config.trigger == 'click'
			)
			{
				this.$element.on('keyup', e => {
					if (e.key === 'Escape')
					{
						this.$element.popover('hide');
						this.$element.blur();
					}
				});
			}

			this.$element.on('hidden.bs.popover', function (e) {
				$(this).removeClass('active');
			});
		}

		static show(node, name, options) {

			let popoverApi = $(node).data('bs.popover');

			if (popoverApi == undefined)
			{
				new Popover(node, name, options);
			}
			else
			{
				popoverApi.config = Object.assign(popoverApi.config, options);
			}

			$(node).popover('show');
		}

		static hide(node) {

			let popoverApi = $(node).data('bs.popover');

			if (popoverApi != undefined)
			{
				$(node).popover('hide');
			}

		}

		static dispose(node, name, options) {

			$(node).popover('dispose');
		}
	}

	return Popover;
})(jQuery);

export default Popover;
